module.exports = __webpack_public_path__ + "static/img/gold_bar_bg.49119d90.png";